import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import axios from "axios";
import DossierDocumentsDeleteTable from "./DossierDocumentsDeleteTable.jsx";
import PreviewFile from "./PreviewFile.jsx";
import { showFile } from '../functions';
import { LangContext } from "../LangContext.jsx";
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
import { tr } from "date-fns/locale";
class DeletePersonDocumentsModal extends Component {
    static contextType = LangContext; 
    constructor(props) {
        super(); 
        this.state = { 
            detail:[],   
            isCheckedOnly: false,
            isCheckedRecurrent: false,
            isCheckedHistory: false,
            documentLoaded: false,
            selectedDocumentIds: [],
            totalOnce: 0,
            totalRecurrent: 0,
            totalDocuments:0,
            totalHistoryDocuments:0,
            historyFiles:[],
            subtitle:"Unicamente se podrán borrar documentos que estén en los estatus de Por revisar, Aprobados ó Rechazados",
        };  
    } 

    handleSelectAll() {
        const allSelected = Object.values(this.state.selectedDocuments).every(v => v);
        const newSelectedDocuments = Object.keys(this.state.selectedDocuments).reduce((acc, id) => ({
            ...acc,
            [id]: !allSelected,
        }), {});
        this.setState({ selectedDocuments: newSelectedDocuments });
    }
    async getDocuments(){ 
        axios.get('/api/dossiers/documents/'+this.props.person_provider_id).then(res=>{
            this.setState({ detail: res.data, documentsLoaded: true });
            const totalOnce =
                this.state.detail.frequencyOnly.loaded.length +
                this.state.detail.frequencyOnly.approved.length +
                this.state.detail.frequencyOnly.rejected.length
            const totalRecurrent = 
                this.state.detail.frequencyRecurrent.loaded.length +
                this.state.detail.frequencyRecurrent.approved.length +
                this.state.detail.frequencyRecurrent.rejected.length
            const totalHistoryDocuments = this.state.detail.frequencyRecurrent.expired.length;
            const totalDocuments = totalOnce + totalRecurrent +  this.state.detail.frequencyOnly.pending.length +  this.state.detail.frequencyRecurrent.loaded.length;
            this.setState({ totalOnce, totalRecurrent,totalDocuments,totalHistoryDocuments }); 
        }) 
    } 
    handleOpenModalDeletePersonDocuments = () => { 
        this.setState({ 
            isCheckedOnly: false,
            isCheckedHistory: false,
            isCheckedRecurrent: false,
            documentLoaded: false,
            selectedDocumentIds: [],
            totalOnce: 0,
            totalRecurrent: 0,
            totalDocuments: 0,
        },function(){
            this.getDocuments();
        });  
    } 

    handleSelectDocument = (updatedDocuments, section, status, selected) => {
        this.setState(prevState => {
            let newState = {
                detail: {
                    ...prevState.detail,
                    [section]: {
                        ...prevState.detail[section],
                        [status]: updatedDocuments 
                    }
                }
            };
            if (section === 'frequencyOnly') {
                newState.isCheckedOnly = selected ? prevState.isCheckedOnly : false;
                const allChecked = updatedDocuments.every(doc => doc.selected);
                if (allChecked) {
                    newState.isCheckedOnly = true;
                }
            } else if (section === 'frequencyRecurrent') {
                newState.isCheckedRecurrent = selected ? prevState.isCheckedRecurrent : false;
                const allChecked = updatedDocuments.every(doc => doc.selected);
                if (allChecked) {
                    newState.isCheckedRecurrent = true;
                }
            }
            return newState;
        });
    };

    handleDeleteDocuments = ()=>{ 

        const { lang } = this.context; 
        const { detail } = this.state;  
        const selectedIds = [];   
        ['frequencyOnly', 'frequencyRecurrent','expired'].forEach(section => { 
            if(section == 'expired'){
                if(this.state.detail['expired']?.documents?.groups){
                    this.state.detail['expired'].documents.groups.map((group, i) => {
                        group.documents.map((doc, i) => {
                            if(doc.selected){
                                selectedIds.push(doc.id);
                            }
                        });
                    })
                }
            }else{
                Object.keys(detail[section]).forEach(status => {
                    const documents = detail[section][status];
                    const selectedDocuments = documents.filter(doc => doc.selected); 
                    selectedIds.push(...selectedDocuments.map(doc => doc.id));
                });
            }
            
        }); 
        swal.fire({ 
            html: '¿Estás seguro que deseas borrar los documentos seleccionados?<div class="mt-5 col-md-12 alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert"> <div> <span class="flaticon2-warning mr-2 icon-3x"></span> </div> <div>  Es importante considerar ya que una vez que se borre el documento no habrá forma de recuperarlo. </div> </div>',
            showCancelButton: true,
            icon: "warning", 
            buttonsStyling: false,
            confirmButtonText: "Borrar",
            cancelButtonText:  lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) { 
                window.blockUI(); 
                axios.post('/api/document_dossier/documents/delete',{
                    ids:selectedIds
                }).then(res=>{ 
                    window.unblockUI()
                    swal.fire({
                        text: 'Se han borrado los documentos',
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText:lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) { 
                        location.reload()
                    });
                })
            }
        });
        return selectedIds;
    }

    handleSelectAllDocuments = () => {
        this.setState(prevState => {
            const newIsCheckedOnly = !prevState.isCheckedOnly; 
            const updateDocuments = docs => (docs ? docs.map(doc => ({
                ...doc,
                selected: newIsCheckedOnly
            })) : []);
            return {
                isCheckedOnly: newIsCheckedOnly,
                detail: {
                    ...prevState.detail,
                    frequencyOnly: {
                        ...prevState.detail.frequencyOnly,
                        loaded: updateDocuments(prevState.detail.frequencyOnly.loaded),
                        approved: updateDocuments(prevState.detail.frequencyOnly.approved),
                        rejected: updateDocuments(prevState.detail.frequencyOnly.rejected)
                    }
                }
            };
        });
    }; 
    handleSelectAllHistoryDocuments = () => {

        this.setState(prevState => {
            const newCheckedState = !prevState.isCheckedHistory;
            prevState.detail?.expired.documents.groups.forEach(d => {
                const collapseElement = document.getElementById(`collapse${d.header.id}`);
                if (collapseElement) {
                    if (newCheckedState) {
                        collapseElement.classList.add('show'); // Expandir
                    } else {
                        collapseElement.classList.remove('show'); // Colapsar
                    }
                }
            });
            const newIsCheckedHistory = !prevState.isCheckedHistory; 
            // Hacemos una copia profunda de los grupos de documentos de 'expired'
            const updatedExpiredGroups = prevState.detail['expired'].documents.groups.map(group => {
                // Hacemos una copia de los documentos dentro de cada grupo
                const updatedDocuments = group.documents.map(doc => ({
                    ...doc,  // Copia del documento
                    selected: newIsCheckedHistory  // Actualizamos el estado de selección
                }));
                return {
                    ...group,  // Copia del grupo
                    documents: updatedDocuments  // Reemplazamos los documentos con los actualizados
                };
            });
    
            return {
                isCheckedHistory: newIsCheckedHistory,
                detail: {
                    ...prevState.detail,  // Copiamos el resto del estado de 'detail'
                    expired: {
                        ...prevState.detail.expired,  // Copiamos el estado de 'expired'
                        documents: {
                            ...prevState.detail.expired.documents,  // Copiamos los documentos de 'expired'
                            groups: updatedExpiredGroups  // Reemplazamos los grupos con los actualizados
                        }
                    }
                }
            };
        });
    };
    
    handleSelectAllDocumentsFrequency = () => {
        this.setState(prevState => {
            const newIsCheckedRecurrent = !prevState.isCheckedRecurrent;
            const updateDocuments = docs => (docs ? docs.map(doc => ({
                ...doc,
                selected: newIsCheckedRecurrent
            })) : []);
            return {
                isCheckedRecurrent: newIsCheckedRecurrent,
                detail: {
                    ...prevState.detail,
                    frequencyRecurrent: {
                        ...prevState.detail.frequencyRecurrent,
                        loaded: updateDocuments(prevState.detail.frequencyRecurrent.loaded),
                        approved: updateDocuments(prevState.detail.frequencyRecurrent.approved),
                        rejected: updateDocuments(prevState.detail.frequencyRecurrent.rejected)
                    }
                }
            };
        });
    }; 
    isButtonEnabled = () => {
        const { detail } = this.state;
        const selectedIds = [];
        ['frequencyOnly', 'frequencyRecurrent','expired'].forEach(section => {
            if(section == 'expired'){ 
                if(this.state.detail['expired']?.documents?.groups){
                    this.state.detail['expired'].documents.groups.map((group, i) => {
                        group.documents.map((doc, i) => {
                            if(doc.selected){
                                selectedIds.push(doc.id);
                            }
                        });
                    })
                }
            }else{
                Object.keys(detail[section] || {}).forEach(status => {
                    const documents = detail[section][status] || [];
                    const selectedDocuments = documents.filter(doc => doc.selected);
                    selectedIds.push(...selectedDocuments.map(doc => doc.id));
                });
            } 
        });  
        

        if (selectedIds.length > 0) {
            console.log('totalDocuments',this.state.totalDocuments)
            console.log('selectedIds',selectedIds)
            if(this.state.totalDocuments == selectedIds.length){
            //    return true;
            }
            return false;
        }else{
            return true;
        }
    };
    showWarning = () => {
        return false;
    } 
    handleSelectExpiredDocument = (docId) => {
        // Clonar el estado para no mutarlo directamente
        const updatedDocuments = this.state.detail.expired.documents.groups.map(group => {
          // Para cada grupo de documentos, mapeamos los documentos
            group.documents = group.documents.map(doc => {
                // Si el documento ID coincide, cambiamos su estado `selected`
                if (doc.id === docId) {
                doc.selected = !doc.selected; // Cambiar el estado seleccionado (true/false)
                }
                return doc;
            });
            return group;
            }); 
            this.setState({
            detail: {
                ...this.state.detail,
                expired: {
                ...this.state.detail.expired,
                documents: {
                    ...this.state.detail.expired.documents,
                    groups: updatedDocuments
                }
                }
            }
            });
    };
    render() {

        const { lang } = this.context;
        const selectedDocumentsIds = this.state.selectedDocumentIds;
        const isButtonEnabled = this.isButtonEnabled();  
        const showWarning = this.showWarning(); 
        return (
            <div className="modal fade" id="deletePersonDocumentsModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content" style={{ background: '#f5f5f5' }}>
                        <div className="modal-body px-15 py-10 ">
                            <h5 className="text-dark font-weight-bold my-1 mr-5">
                            Borrar Documentos  
                            </h5>
                            <p className="text-muted">
                                {this.state.subtitle}
                            </p>
                            <ul className="nav nav-tabs nav-tabs-line">
                                <li className="nav-item">
                                    <a className="nav-link active" 
                                        onClick={() => this.setState({ subtitle: 
                                            'Unicamente se podrán borrar documentos que estén en los estatus de Por revisar, Aprobados ó Rechazados' 
                                    })} 
                                    data-toggle="tab" href="#kt_tab_pane_delete_1">{lang.get('messages.unicos')} &nbsp; <span className="badge badge-secondary"> { this.state.totalOnce}</span></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link"
                                        onClick={() => this.setState({ subtitle: 
                                        'Unicamente se podrán borrar documentos que estén en los estatus de Por revisar, Aprobados ó Rechazados' 
                                })} 
                                    data-toggle="tab" href="#kt_tab_pane_delete_2">{lang.get('messages.recurrentes')} &nbsp; <span className="badge badge-secondary"> { this.state.totalRecurrent}</span></a>
                                </li>  
                                <li className="nav-item">
                                    <a 
                                        onClick={() => this.setState({ subtitle: 
                                        'Borrar documentos del Historial' 
                                })} 
                                    className="nav-link" data-toggle="tab" href="#kt_tab_pane_delete_3">{lang.get('messages.historial')} &nbsp;<span className="badge badge-secondary">{this.state.totalHistoryDocuments}</span></a>
                                </li>
                            </ul>
                            <div className="tab-content mt-5" id="myTabContent">
                                {this.state.documentsLoaded && <>
                                    <div className="tab-pane fade show active"  id="kt_tab_pane_delete_1"   role="tabpanel"   aria-labelledby="kt_tab_pane_1"
                                        style={{
                                            overflowX: 'auto',
                                            maxHeight: '370px'
                                        }} >
                                        <div className="d-flex gap-1 align-items-center">

                                        <label className="checkbox checkbox-outline align-items-center mb-2"> 
                                                        <input 
                                                            type="checkbox" 
                                                            name="extensions" 
                                                            onMouseDown={(e) => e.stopPropagation()}  
                                                            checked={this.state.isCheckedOnly} 
                                                            onChange={() => this.handleSelectAllDocuments( )}
                                                        />
                                                        <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                    </label>
 
                                                <span className="text-primary">Seleccionar todos los documentos</span>
                                        </div>
                                        
                                        <table className="table table-borderless m-0 table-valign">
                                            <tbody>   
                                            <DossierDocumentsDeleteTable
                                                onSelectDocument={this.handleSelectDocument}
                                                title={lang.get('messages.por_revisar')}
                                                param={this.props.usermode == 'provider' ? 'show_file' : 'review_file'}
                                                showRejectedMessage={false}
                                                user_mode={this.props.usermode}
                                                personProviderId={this.props.id}
                                                section="frequencyOnly"
                                                status="loaded"
                                                type="only"
                                                documents={this.state.detail?.frequencyOnly.loaded}
                                                has_doc_2_sign_enabled={this.props.has_doc_2_sign_enabled}
                                            /> 
                                            <DossierDocumentsDeleteTable
                                                onSelectDocument={this.handleSelectDocument}
                                                title={this.props.has_doc_2_sign_enabled === 'true' 
                                                ? lang.get('messages.aprobados__firmados') 
                                                :  lang.get('messages.aprobados') }
                                                param="show_file"
                                                section="frequencyOnly"
                                                status="approved"
                                                showRejectedMessage={false}
                                                user_mode={this.props.usermode}
                                                personProviderId={this.props.id}
                                                type="only"
                                                documents={this.state.detail?.frequencyOnly.approved}
                                                has_doc_2_sign_enabled={this.props.has_doc_2_sign_enabled}
                                            />
                                            {/*
                                            <DossierDocumentsDeleteTable
                                                onSelectDocument={this.handleSelectDocument}
                                                title={lang.get('messages.rechazados')}
                                                param="show_file"
                                                section="frequencyOnly"
                                                status="rejected"
                                                showRejectedMessage={true}
                                                user_mode={this.props.usermode}
                                                personProviderId={this.props.id}
                                                type="only"
                                                documents={this.state.detail?.frequencyOnly.rejected}
                                                has_doc_2_sign_enabled={this.props.has_doc_2_sign_enabled}
                                            />
                                             */}
                                            </tbody>
                                        </table>  
                                    </div>
                                    <div className="tab-pane fade" id="kt_tab_pane_delete_2" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div className="d-flex gap-1 align-items-center"> 
                                            <label className="checkbox checkbox-outline align-items-center mb-2"> 
                                                <input  type="checkbox" checked={this.state.isCheckedRecurrent} 
                                                    onChange={() => this.handleSelectAllDocumentsFrequency( )}/>
                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                            </label>   
                                            <span className="text-primary">Seleccionar todos los documentos</span>
                                        </div> 
                                        <table className="table table-borderless m-0 table-valign">
                                            <tbody> 
                                            <DossierDocumentsDeleteTable
                                                onSelectDocument={this.handleSelectDocument}
                                                title={lang.get('messages.por_revisar')}
                                                param={this.props.usermode == 'provider' ? 'show_file' : 'review_file'}
                                                showRejectedMessage={false}
                                                section="frequencyRecurrent"
                                                status="loaded"
                                                personProviderId={this.props.id}
                                                user_mode={this.props.usermode}
                                                type="recurrent"
                                                documents={this.state.detail?.frequencyRecurrent.loaded}
                                            />
                                            <DossierDocumentsDeleteTable
                                                onSelectDocument={this.handleSelectDocument}
                                                title={lang.get('messages.aprobados')}
                                                param="show_file"
                                                section="frequencyRecurrent"
                                                status="approved"
                                                showRejectedMessage={false}
                                                user_mode={this.props.usermode}
                                                personProviderId={this.props.id}
                                                type="recurrent"
                                                documents={this.state.detail?.frequencyRecurrent.approved}
                                            />
                                            {/*
                                            <DossierDocumentsDeleteTable
                                                onSelectDocument={this.handleSelectDocument}
                                                title={lang.get('messages.rechazados')}
                                                param="show_file"
                                                section="frequencyRecurrent"
                                                status="rejected"
                                                showRejectedMessage={true}
                                                user_mode={this.props.usermode}
                                                personProviderId={this.props.id}
                                                type="recurrent"
                                                documents={this.state.detail?.frequencyRecurrent.rejected}
                                            />
                                             */}
                                            </tbody>
                                        </table>
                                    </div> 
                                    <div className="tab-pane fade" id="kt_tab_pane_delete_3" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div className="d-flex gap-1 align-items-center">
                                            <label className="checkbox checkbox-outline align-items-center mb-2"> 
                                                <input type="checkbox"   name="extensions"   checked={this.state.isCheckedHistory} 
                                                    onChange={() => this.handleSelectAllHistoryDocuments( )} />
                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                            </label>  
                                            <span className="text-primary">Seleccionar todos los documentos</span>
                                        </div>
                                        <div className="accordion text-dark-75  font-size-lg" id="accordionExample">
                                        { this.state.detail?.expired.documents.groups.map((d, i) => {
                                            {  
                                            return  <div className="card" key={i}>
                                                        <div className="card-header-collapse" id="headingOne">
                                                            <div className="mb-0 d-flex align-items-center">
                                                                <button className="btn btn-block text-left mr-2 text-dark-75 font-weight-bolder font-size-lg"
                                                                        type="button" data-toggle="collapse"
                                                                        onClick={ ()=>{ this.getHistoryFile(d.header.id,1) } }
                                                                        data-target={`#collapse${d.header.id}`}
                                                                        aria-expanded="false" aria-controls="collapseOne">
                                                                        <i className="flaticon2-plus mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                                        <i className="flaticon2-line mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                                        { d.header.title } &nbsp;<span className="badge rounded-circle text-white" style={{"backgroundColor": "#B5B5C3"}}>{d.total_documents}</span>
                                                                        <span className="text-dark-50" style={{"fontSize": "12px", "marginLeft": "130px"}}>
                                                                            <span className="tooltip-mdl"> 
                                                                            </span> 
                                                                        </span>
                                                                </button>
                                                                <div className="pr-4 font-weight-bolder">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id={`collapse${d.header.id}`} className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                            <div className="card-body">
                                                                <table className="table table-borderless m-0 table-valign">
                                                                    <thead>
                                                                        <tr>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    { d.documents.map((d, i) => {
                                                                    return <tr >
                                                                        <td style={{width: "20px"}}>
                                                                        <label className="checkbox checkbox-outline align-items-center mb-2"> 
                                                                            <input type="checkbox"   name="extensions"  checked={d.selected || false}
                                                                                onChange={() => this.handleSelectExpiredDocument(d.id)} />
                                                                                <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                                        </label> 
                                                                            </td>
                                                                            <td style={{width: "20px"}}><img src={"/assets/img/" + window.getMimeSVG(d.file.extension!=undefined && d.file.extension.length>0 ? d.file.extension : d.file.path)}/></td>
                                                                            <td>
                                                                                <b>{d.file.title} 
                                                                                <strong>
                                                                                &nbsp; {new Date(d.start_date).toLocaleString('es-ES', { month: 'long', year: 'numeric' })
                                                                                        .replace(/^\w/, c => c.toUpperCase())}
                                                                                </strong>   
                                                                                </b>
                                                                                <div className="text-dark-65 font-size-sm" >
                                                                                ( {lang.get('messages.solicitado_el')} {  d.created  }
                                                                                    &nbsp;
                                                                                    {lang.get('messages.cargado_el')} {  d.loaded  }
                                                                                    &nbsp;
                                                                                    {lang.get('messages.aprobado_el')} { d.approved  }
                                                                                    &nbsp;
                                                                                    {lang.get('messages.expiro_el')} {d.expired })
                                                                                </div>
                                                                            </td>
                                                                            <td colSpan="2" className="text-right">  
                                                                            { (d.file.extension == 'pdf' || d.file.extension == 'png' || d.file.extension == 'jpg' || d.file.extension == 'jpeg' || d.file.extension == 'gif' || d.file.extension == 'svg' ) &&
                                                                            <>
                                                                                <a 
                                                                                    href="#" 
                                                                                    onClick={() => showFile( `/files/${d.id}` , d.file.extension)}
                                                                                    className="text-primary"
                                                                                >
                                                                                <span className="flaticon2-file-2 mr-2"></span>Vista Previa
                                                                                </a>
                                                                            </>
                                                                            }
                                                                                {(d.file.extension == 'doc' || d.file.extension == 'docx') &&
                                                                            <>
                                                                                <PreviewFile  doc={d}/> 
                                                                            </>
                                                                            }
                                                                            </td>
                                                                        </tr>
                                                                    })}
                                                                    </tbody>
                                                                </table> 
                                                            {this.state.historyTotal > this.state.maxRecords  &&
                                                            <SimplePagination
                                                                    updateCurrentPage={this.updateCurrentHistoryPage}
                                                                    currentPage={this.state.historyPage}
                                                                    totalFiles={this.state.historyTotal}
                                                                    split={this.state.maxRecords} />}
                                                        </div>
                                                    </div>
                                                </div>
                                            }})}
                                        </div>
                                    </div>
                                </>} 
                                <div className="text-right mb-5 mt-5">
                                    {showWarning == true && 
                                    <>
                                        <div class="mt-5 col-md-12 alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert"> 
                                            <div> 
                                                <span class="flaticon2-warning mr-5 icon-3x"></span>
                                            </div>
                                            <div>
                                            Nota: El expediente no podrá quedarse sin ningún documento.
                                            </div> 
                                        </div> 
                                    </>
                                    } 
                                    <button class="btn btn-secondary font-weight-bolder px-10 mr-5" data-dismiss="modal">Cancelar</button>
                                    <button style={{ width:'120px'}} type="button" className="btn btn-danger" onClick={this.handleDeleteDocuments} disabled={isButtonEnabled}>
                                       Borrar
                                    </button>
                                </div> 
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        );
    }
}

export default DeletePersonDocumentsModal;

if (document.getElementById('DeletePersonDocumentsModal')) {
    ReactDOM.render(<DeletePersonDocumentsModal />, document.getElementById('DeletePersonDocumentsModal'));
}